import {
  StorageProtectionExclusionsSection,
  StorageProtectionIcapSection,
} from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface StorageProtectionIcapFormValue {
  uiSettings: { storageProtection: { icap: StorageProtectionIcapSection } };
}
export interface StorageProtectionExclusionsFormValue {
  uiSettings: { storageProtection: { exclusions: StorageProtectionExclusionsSection } };
}

// searchable keywords
export enum StorageIcapSearchableKeywords {
  StorageOnAccessScanning = 'StorageOnAccessScanning',
  StorageConnectionSettings = 'StorageConnectionSettings',
  StorageProtection = 'StorageProtection',
  StorageIcap = 'StorageIcap',
  StorageServiceName = 'StorageServiceName',
  StorageNonSecurePort = 'StorageNonSecurePort',
  StorageSecurePort = 'StorageSecurePort',
  StorageArchiveScanningSettings = 'StorageArchiveScanningSettings',
  StorageScanArchive = 'StorageScanArchive',
  StorageArchiveMaxSize = 'StorageArchiveMaxSize',
  StorageArchiveMaxDepth = 'StorageArchiveMaxDepth',
  StorageCongestionControl = 'StorageCongestionControl',
  StorageDropConnection = 'StorageDropConnection',
  StorageMaxConnections = 'StorageMaxConnections',
  StorageScanActions = 'StorageScanActions',
  StorageDefaultAction = 'StorageDefaultAction',
}
export enum StorageExclusionsSearchableKeywords {
  StorageExclusions = 'StorageExclusions',
  StorageExport = 'StorageExport',
  StorageImport = 'StorageImport',
  StorageWildcard = 'StorageWildcard',
  StorageHash = 'StorageHash',
}
